import React from "react";
import styles from "./read-only-info-wrapper-for-sources-list-view.module.scss";

interface ReadOnlyInfoWrapperPropTypes {
  label: string;
  text: string;
}

const cssClassName = "read-only-info-wrapper-for-sources-list-view";

export const ReadOnlyInfoWrapperForSourcesListView = ({
  label,
  text,
}: ReadOnlyInfoWrapperPropTypes) => {
  return (
    <div className={styles[cssClassName]}>
      <p className={styles[`${cssClassName}__label`]}>{label}</p>
      <p className={styles[`${cssClassName}__read-only-text`]}>{text}</p>
    </div>
  );
};
